import { get } from '../api';

const getRelationship = ({ config, id = '', relationshipId = '', relationship, type }) =>
  get(`/${type}/${id}/${relationship}/${relationshipId}`, config);

export default getRelationship;
